<template>
  <a href="#" @click.prevent="downloadURI(uri)" >
    <mdb-icon icon="file-download" class="mr-1" />
    {{ name }}
  </a>
</template>

<script>
import {
  mdbIcon

} from "mdbvue";
export default {
  name: "DownloadLink",
  props: ['uri','name'],
  components: {
    mdbIcon
  },
  data() {
    return {
      contentBase: process.env.VUE_APP_CONTENT_2_URL,
      token: process.env.VUE_APP_CONTENT_2_REST_TOKEN
    }
  },
  methods: {
    downloadURI: function(uri){
      const link = document.createElement("a");
      link.href = this.contentBase+'/assets/'+uri+'/?download&access_token='+this.token;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>

</style>